define('views/linkedcards/linkedcards',[
    "backbone",
    "views/_base/baseview",
    "text!views/linkedcards/linkedcards.html",
    "models/linkedcards/linkedcard_collection",
    "views/linkedcards/linkedcard",
    "models/linkedcards/linkedcard",
    "views/user/register/financial/visaredirect",
    "views/linkedcards/linkedcardlistitem",
], function (Backbone, BaseView, Template, LinkedCardList, LinkedCardView, LinkedCard, VisaRedirect, LinkedCardListView) {
    "use strict";

    return BaseView.extend({
        template : _.template(Template),
        isRender : false,
        needsAuth: true,
        tagName  : "ul",
        events   : {
            "click .js-addLinkedCard": "addLinkedCard"
        },
        initialize: function (options) {
            options = options || {};
            // Element to insert subview
            this.elementName = options.elementName;
            // State is the location of the app i.e. Shop, Wallet, Activity, etc.
            this.state = options.state;
            this.ecardView = options.ecardView;
            this.totalCards = 0;
            this.showBtn = options.showBtn;
            this.LCEvents = _.extend({}, Backbone.Events);
            this.walletCount = options.walletCount;
            this.noCardsCallback = options.noCardsCallback;
            _.bindAll(this, "refreshCards");
            this.LCEvents.bind("refreshCards", this.refreshCards);
            BaseView.prototype.initialize(this);
        },
        render: function () {
            this.$el.html(this.template);
            return this;
        },
        loadData: function () {
            var that = this;

            if(this.state == 'wallet'){
                var instanceURL = pf.consumerURL + '/LinkedCards?smc=true';
            } else {
                // var instanceURL = pf.consumerURL + '/LinkedCards?sa=true';
                var instanceURL = pf.consumerURL + '/LinkedCards?smc=true&sa=true',
                    mastercard = pf.getContent('ecard.config.mastercard_payment_option');
                
                if(mastercard){
                    instanceURL += '&smc=true';
                }
            }

            this.collection = new LinkedCardList({ instanceURL: instanceURL });
            this.collection.fetch({
                success: function (coll, resp) {
                    if (resp) {
                        that.render();
                        if (coll && coll.models)
                            that.collection = coll.models;
                        that.addAll();
                    }
                }
            });
        },
        refreshCards: function(that) {
            var that = (that) ? that : this;
            that.loadData();
        },
        addOne: function (linkedcard,i) {
            if(linkedcard.CardTypeID == 1 && this.state == 'ecard'){
                this.ecardView.populateGprAccount(linkedcard);
                this.ecardView.setGprAccountModel(linkedcard);
            } else {
                var linkedcardView = (this.state == 'wallet') ? new LinkedCardView({ model: linkedcard, LCEvents: this.LCEvents, LCView: this }) : new LinkedCardListView({ model: linkedcard, LCEvents: this.LCEvents, ecardView: this.ecardView });
                if(this.state == 'ecard' && i > 2){
                    $(linkedcardView.el).addClass('hidden');
                }
                // Temporary work-around to ensure Wallet view refreshes cards after Financial Login
                if(this.state == 'wallet'){
                    $(this.elementName).append(linkedcardView.el);
                } else {
                    this.$el.append(linkedcardView.el);
                }
            }
        },
        addAll: function () {
            var that = this;
            if(this.state == 'wallet'){
                $(this.elementName).html('');
            } else {
                this.$el.html('');
            }
            
            if(this.collection != null && this.collection.length > 0){
                this.totalCards = this.collection.length;
                this.collection.forEach(function(card,i){
                    that.addOne(card,i);
                }, this);
                
                // On the eCard Purchase view show the Show All button if there are more than 2 linked cards
                if(this.state == 'ecard' && this.totalCards > 2){
                    $('.js-linkedCardListShowAllBtn').fadeIn();
                }
                // Send the Wallet View the count to display
                if(this.state == 'wallet'){
                    this.walletCount(this.totalCards);
                }
            } else {
                if(this.noCardsCallback){
                    this.noCardsCallback();
                }
            }
            if(this.state == 'wallet'){
                $('.js-account-add-linked-card').click(function (e) { that.addLinkedCard(); });
            }
        },
        addLinkedCard: function (e) {
            pf.navigate('wallet/linkcard');

            // var visaRedirectView = new VisaRedirect({ elementName: "#mainRegion" });
            // pf.show(visaRedirectView);

            //var that = this;

            //var card = new LinkedCard(
            //    {
            //        NSID: enums.networkSources.Visa
            //    });
            //$.ajax({
            //    type: "POST",
            //    url: pf.consumerURL + "/LinkedCards",
            //    data: JSON.stringify(card),
            //    async: true,
            //    contentType: "application/json; charset=utf-8",
            //    traditional: true,
            //    success: function (response) {
            //        if (response) {
            //            var url = pf.isMobile() ? response.mobEnrollURL : response.webEnrollURL;

            //            url += "?info={EUID:" + response.lcGUID + ",FN:" + pf.session.get("FirstName") + ",LN:" + pf.session.get("LastName") + "}";
            //            //window.open(url, "_blank");
            //            location.assign(url);
            //        }
            //        else
            //            jAlert("There was an error trying to add a card. Please try again")
            //    },
            //    error: function (response) {
            //        jAlert("There was an error trying to add a card. Please try again")
            //    }
            //});
        },
       
        close: function () {
            this.collection = null;
        }
    });
});

